import { createEvent } from '@cobuildlab/react-simple-state';
import { Comment, PostComment, ReplyComment } from './comment-types';

export const fetchCommentsEvent = createEvent<{
  comments: PostComment[];
  count: number;
}>({
  initialValue: {
    comments: [],
    count: 0,
  },
});

export const fetchCommentsErrorEvent = createEvent();

export const fetchCommentUrlEvent = createEvent<{
  comments: PostComment[];
}>({
  initialValue: {
    comments: [],
  },
});

export const fetchCommentUrlErrorEvent = createEvent();

export const fetchCommentEvent = createEvent<{
  comments: Comment[];
  count: number;
}>({
  initialValue: {
    comments: [],
    count: 0,
  },
});

export const fetchCommentErrorEvent = createEvent();

export const changeCommentStatusEvent = createEvent<{ comment?: Comment }>({
  initialValue: {
    comment: undefined,
  },
});

export const changeCommentStatusErrorEvent = createEvent();

export const changeReplyCommentStatusEvent = createEvent<{ comment?: Comment }>(
  {
    initialValue: {
      comment: undefined,
    },
  },
);

export const changeReplyCommentStatusErrorEvent = createEvent();


export const fetchSearchCommentsEvent = createEvent<{
  comments: Comment[];
  count: number;
}>({
  initialValue: {
    comments: [],
    count: 0,
  },
});

export const fetchSearchCommentsErrorEvent = createEvent();

export const fetchSearchRepliesEvent = createEvent<{
  comments: ReplyComment[];
  count: number;
}>({
  initialValue: {
    comments: [],
    count: 0,
  },
});

export const fetchSearchRepliesErrorEvent = createEvent();

export const changeMultipleCommentStatusEvent = createEvent<{
  comments?: { count: number };
}>({
  initialValue: {
    comments: { count: 0 },
  },
});

export const changeMultipleCommentStatusErrorEvent = createEvent();

export const changeMultipleRepliesStatusEvent = createEvent<{
  comments?: { count: number };
}>({
  initialValue: {
    comments: { count: 0 },
  },
});

export const changeMultipleRepliesStatusErrorEvent = createEvent();